import styled from 'styled-components';
import { BREAKPOINT_MEDIUM } from 'global-search-shared';
export const StyledSearchInput = styled.input.withConfig({
  displayName: "StyledSearchInput",
  componentId: "dgg99n-0"
})(["display:block !important;flex-grow:1;outline:none;width:100%;height:", ";font:", " !important;text-indent:8px;border:", " !important;transform:translateZ(0);will-change:height,color;background:", ";border-radius:", ";color:", ";padding:", " !important;padding-right:", ";@media (max-width:", "px){padding-left:30px !important;}&::placeholder{color:var(--search-icon-fill);}"], ({
  isOpen
}) => isOpen ? '48px' : '32px', ({
  theme
}) => `${theme.typography['body-100'].fontWeight} ${theme.typography['body-100'].fontSize}/${theme.typography['body-100'].lineHeight} ${theme.typography['body-100'].fontFamily}`, ({
  isOpen,
  theme
}) => isOpen ? `1px solid ${theme.color['border-primary-default']}` : '0', ({
  isOpen,
  theme
}) => isOpen ? theme.color['fill-surface-default'] : theme.color['fill-accent-neutral-subtle'], ({
  isOpen
}) => isOpen ? '10px' : '8px', ({
  isOpen,
  theme
}) => !isOpen && `${theme.color['border-core-subtle']} !important`, ({
  isOpen,
  theme
}) => isOpen ? `${theme.space['200']} 36px ${theme.space['200']} 42px` : `0 0 0 40px`, ({
  hasValue
}) => hasValue && '36px !important', BREAKPOINT_MEDIUM - 1);